import { barsViz } from './bars';
import { waveViz } from './wave';
import { ringViz } from './ring';
import { rainViz } from './rain';
import { bloomViz } from './bloom';
import { tunnelViz } from './tunnel';
import { spectrumViz } from './spectrum';
import { starfieldViz } from './starfield';
import { lyricsViz } from './lyrics';
import { scopeViz } from './scope';
import { lissajousViz } from './lissajous';
import { spectrogramViz } from './spectrogram';
import { ridgeViz } from './ridge';
import { ribbonViz } from './ribbon';
import { constellationViz } from './constellation';
import { meshViz } from './mesh';
import { radialWaveViz } from './radialWave';
import { emojiStreamViz } from './emojiStream';
import { asciiViz } from './ascii';
import { cubesViz } from './cubes';
import { dancersViz } from './dancers';
import type { Visualizer } from './types';

export const VISUALIZERS: Visualizer[] = [
  lyricsViz,
  dancersViz,
  emojiStreamViz,
  asciiViz,
  cubesViz,
  scopeViz,
  lissajousViz,
  radialWaveViz,
  ribbonViz,
  ridgeViz,
  spectrogramViz,
  meshViz,
  constellationViz,
  tunnelViz,
  barsViz,
  spectrumViz,
  waveViz,
  ringViz,
  starfieldViz,
  rainViz,
  bloomViz,
];

export function getVisualizer(id: string): Visualizer {
  return VISUALIZERS.find((v) => v.id === id) ?? lyricsViz;
}
